import { backendErrorsHelper } from "@gymflow/helpers";
import { AxiosInstance, isAxiosError } from "axios";
import { MANUALLY_HANDLED_ERROR_CODES } from "libs/helpers/src/constants/ManuallyHandledErrorCodes";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ToastContext } from "./ToastProvider/context";

export const ErrorParserProvider = ({
  children,
  api,
}: {
  children: React.ReactNode;
  api: AxiosInstance;
}) => {
  const { t, i18n } = useTranslation();
  const { toast } = useContext(ToastContext);
  useEffect(() => {
    const interceptorId = api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (!isAxiosError(error)) return Promise.reject(error);
        if (
          error.config?.method !== "get" &&
          error.status !== 426 &&
          error.response?.data
        ) {
          const parsedError = backendErrorsHelper.parseError(error);
          if (!MANUALLY_HANDLED_ERROR_CODES.includes(parsedError.errorCode)) {
            toast({
              message: t("backendErrorsPortal.generic"),
              description:
                parsedError.errorCode &&
                i18n.exists(`backendErrorsPortal.${parsedError.errorCode}`)
                  ? t(
                      `backendErrorsPortal.${parsedError.errorCode}`,
                      parsedError.interpolationMap,
                    )
                  : parsedError.fallbackMessage,
              intent: "error",
            });
          }
        }
        return Promise.reject(error);
      },
    );

    return () => {
      api.interceptors.response.eject(interceptorId);
    };
  }, [toast, t, i18n, api]);
  return children;
};
